/* eslint-disable */
import axios from "axios";


export const base = process.env.VUE_APP_BASE_URL_KAJIADO
export const paysol =  base+"/paysol/index.php";

const base2 ="https://digitechmz.net/portal"
const base3 ="https://api.paysol.co.ke/hrms/"
export const county_logo = base +"/logo/county_logo.png"
export const state_logo = base +"/logo/state_logo.png"
export const login_bg = base +"/logo/bg-auth-overlay.png"

export const hospital = base+"/hospital/index.php";

export const rent = base+"/rent/index.php";

export const parking =  base+"/parking/index.php";
export const trade =  base+"/trade/index.php";
export const econstruction =  base+"/econstruction/index.php";
export const plans =  base+"/econstruction/index.php";
export const econstructionUploads =  base+"/econstruction/";
export const biller =  base+"/biller/index.php";
export const authUrl =  base+"/authentication/";
export const signatureBaseURl =  base+"authentication/assets/signatures/";

export const plotRent =  base+"/plotrent/index.php";
export const plotRentUploads =  base+"/plotrent/uploads/";

export const landRate =  base+"/landrate/index.php";

export const fire =  base+"/fire/index.php";
export const health =  base+"/health/index.php";
export const housing =  base+"/housing/index.php";

export const liquor =  base+"/liquor/index.php";

export const uploadsLiqour = base+"/liquor/uploads/";

export const uploadTemplates = base+"/templates/";



export const execute = (params, url) => {
    const tokenStr = localStorage.getItem("tokenSession"); // Get token dynamically
    return axios.post(url,params,{headers: {"Authorization": `Bearer ${tokenStr}`}})
}

export const executeJson = (params, url) => {
    const tokenStr = localStorage.getItem("tokenSession"); // Get token dynamically
    return axios.post(url, params, {
        headers: {
            "Authorization": `Bearer ${tokenStr}`,
            "Content-Type": "application/json" // Specify JSON content type
        }
    });
}

export const executeDownload = (params, url) => {
    const tokenStr = localStorage.getItem("tokenSession"); // Get token dynamically
    return axios.post(url,params,{headers: {"Authorization": `Bearer ${tokenStr}`}, responseType: 'blob'})
}
export const execute2 = (params, url) => {
    return axios.post(url,params)
}

export const getRight = (accessRole) => {


    // Block download roles
    const selectedRolesString = sessionStorage.getItem("selectedRoles");

    if (!selectedRolesString) {
        return false;
    }

    try {
        const selectedRoles = JSON.parse(selectedRolesString);

        if (!Array.isArray(selectedRoles)) {
            return false;
        }

        let accessRight = false;

        for (const role of selectedRoles) {
            if (role.role === accessRole) {
                accessRight = true;
                break;
            }
        }

        return accessRight;
    } catch (error) {
        return false;
    }


};


// Add this function to your api.js
export const validateSession = async () => {
    const token = sessionStorage.getItem("token") || localStorage.getItem("tokenSession");

    if (!token) {
        return { valid: false };
    }

    const data = new FormData();
    data.append("function", "validateSession");

    try {
        const response = await efromxecute(data, authUrl);
        return response.data;
    } catch (error) {
        console.error("Session validation error:", error);
        return { valid: false };
    }
};
